window.$ = window.jQuery = require('jquery');

require('bootstrap');
require('lightbox2');

$(document).ready(function() {
    $('.registration').submit(function(e) {
        e.preventDefault();

        var form = $(this);
        var formid = form.attr('id');
        var button = $('button[form=' + formid + ']');

        form.find('.form-text').text('');
        button.prop('disabled', true);

        $.ajax({
            method: 'POST',
            url: '/register/ask',
            dataType: 'JSON',
            data: {
                _token: form.find('input[name=_token]').val(),
                email: form.find('input[name=email]').val(),
                domain: form.find('input[name=domain]').val(),
                control: form.find('input[name=control]').val(),
            },
            success: function(data) {
                if (data.status == 'ok') {
                    button.remove();
                    form.parent().empty().append('<div>' + data.message + '</div>');
                }
                else {
                    form.find('input[name=' + data.target + ']').closest('.form-group').find('.form-text').text(data.message);
                    button.prop('disabled', false);
                }
            },
            error: function() {
                button.prop('disabled', false);
            }
        });
    });

    $('.header-wrapper a').click(function(event) {
        var target = $(this.hash);

        if (target.length) {
            event.preventDefault();
            $('html').animate({
                scrollTop: target.offset().top
            }, 500);
        }
    });
});
